import React, {useEffect, useMemo, useState} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {Topbar} from "./Topbar";
import {Searchbar} from "../extras/dropdowns/search/Searchbar";
import {HeaderMenuWrapper} from "./header-menu/HeaderMenuWrapper";
import {AnimateLoading} from "../../../_partials/controls";
import { Searchbarchurned } from "../extras/dropdowns/search/SearchbarChurned";
export function Header(props) {
  console.log(props.userinfo.kyc_status)

  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div className={` ${layoutProps.headerContainerClasses} d-flex align-items-center justify-content-between`}>
          <AnimateLoading />
          {/*begin::Header Menu Wrapper*/}
          {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          {!layoutProps.menuHeaderDisplay && <div />}
          {/*end::Header Menu Wrapper*/}
          {/*begin::Searchbar*/}
          <div className="d-none d-md-block"><Searchbar {...props}/></div>
          {/*end::Searchbar*/}
          {/*begin::Topbar*/}
          <Topbar {...props} />
          {/*end::Topbar*/}
        </div>
        
        {/*end::Container*/}
      </div>
      {/* {props.userinfo.kyc_status === "KYC_APPR" ? 
        <div className="container-fluid bg-danger d-flex align-items-center justify-content-center">
          <div className="row">
            <div className="col-12 text-white font-weight-bold font-size-h6 text-center py-4">
            🔔 Important Update: 19/09/2025, Our Bank details have changed. Please check bank details on invoice before paying. For any queries, please contact your account executive before processing payment.
            </div>
          </div>
        </div>
     : null}  */}
      {/*end::Header*/}
    </>
  );
}
